export default __webpack_public_path__ + "static/media/fMaltoBuza19.16764f9b.png";